export default __webpack_public_path__ + "static/flowerpendantback-4e29726778d838ee556c44fab7c204c4.png";